import { Box, Typography } from '@mui/material';
import NccerLogo from 'assets/images/nccer/logo-negative.png'

import classNames from 'classnames';
import { TypeSafeCredentialDetails } from 'store/types/TypeSafeCredentialDetails';
import styles from './BadgeItem.module.scss';

interface BadgeItemProps {
  dimension?: number;
  typeSafeItem: TypeSafeCredentialDetails;
  isPublic?: boolean;
}

function getLevelStyle(title: string) {
  if (title.includes('One') || title.includes('1')) { return styles.nccerBadgeLevelOne;}
  else if (title.includes('Two') || title.includes('2')) { return styles.nccerBadgeLevelTwo;}
  else if (title.includes('Three') || title.includes('3')) { return styles.nccerBadgeLevelThree;}
  else if (title.includes('Four') || title.includes('4')) { return styles.nccerBadgeLevelFour;}
  else if (title.includes('Five') || title.includes('5')) { return styles.nccerBadgeLevelFive;}
  else { return styles.nccerBadgeSingleLevel; }
}

function getLevelNumber(title: string) {
  if (title.includes('One') || title.includes('1')) { return '1';}
  else if (title.includes('Two') || title.includes('2')) { return '2';}
  else if (title.includes('Three') || title.includes('3')) { return '3';}
  else if (title.includes('Four') || title.includes('4')) { return '4';}
  else if (title.includes('Five') || title.includes('5')) { return '5';}
  else { return ''; }
}

function getStyle(typeSafeItem: TypeSafeCredentialDetails) {
  if(typeSafeItem.ContentFormat === "Simulator" || typeSafeItem.SubmittedWith == 1){
    return classNames(styles.credentialCard,  styles.nccerBadgeSimulator)
  }
  else if(typeSafeItem.ContentType === 'Level'){
    return classNames(styles.credentialCard, styles.nccerBadgeLevel,  getLevelStyle(typeSafeItem.Name))
  }
  else {
    return classNames(styles.credentialCard, styles.nccerBadgeBlue)
  }
}

export function BadgeItem({
  dimension = 220,
  isPublic = false,
  typeSafeItem,
}: BadgeItemProps) {
  
  return (
        <Box
          height={dimension}
          width={dimension}
          className={getStyle(typeSafeItem)}
        >
          <Box className={(typeSafeItem.ContentType === 'Craft' ? styles.craftBoxGrid : styles.boxGrid)}>
            {(typeSafeItem.ContentFormat === "Simulator" || typeSafeItem.SubmittedWith == 1)? (
              <Typography className={styles.catSimLabel} variant={'body2'}>CAT&reg; SIMULATORS</Typography>
            )
              :(
              <Typography className={styles.completion} variant={'body2'}>{typeSafeItem.ContentType} {getLevelNumber(typeSafeItem.Name)} Completion</Typography>
              )}
            <img className={classNames(styles.logo, styles.completion)} src={NccerLogo} alt={'logo'} />
          </Box>
          {typeSafeItem.ContentType === 'Module' && !isPublic ? (
            <Typography className={styles.cardTitle} variant={'body1'}>
              {typeSafeItem.Name} ({typeSafeItem.ContentId}) </Typography>
          ) : (
            <Typography className={(typeSafeItem.ContentType === 'Craft' ? styles.craftTitle :  styles.cardTitle)} variant={'body1'}>
              {typeSafeItem.Name}
            </Typography>
          )}
          {(typeSafeItem.ContentFormat === "Simulator" || typeSafeItem.SubmittedWith == 1) && (<Typography className={styles.simulationCredential} variant={'body1'}>
              Simulation-Based Credential
          </Typography>)}
        </Box>
      
  );
}
